export const de = {
    common: {
        PIN_CODE_LABEL: 'PIN-Code',
        USER_NAME_LABEL: 'Vollständiger Name',
        comment: 'Kommentar',
        year: 'Jahr',
        configuration: 'Konfiguration',
        cancel: 'Abbrechen',
        search: 'Suche',
        remove: 'Entfernen',
        confirmationDialogTitle:
            'Sind Sie sicher, dass Sie diesen Artikel entfernen möchten?',
        selectDate: 'Datum auswählen',
        select: 'Auswählen',
        notFound: 'Nicht gefunden',
        equipmentPickerPlaceholder: 'Ausrüstungsobjekt...',
        searchPlaceholder: 'Suche nach...',
        equipmentTypePickerPlaceholder: 'Art der Ausrüstung...',
        equipmentTypePickerTitle: 'Ausrüstungsart auswählen',
        emptyTableMessage: 'Keine Daten',
        flowPikcerTitle: 'Fluss auswählen',
        selectIcon: 'Symbol auswählen',
        locationPickerTitle: 'Ort auswählen',
        locationPlaceholder: 'Standort...',
        noSublocations: 'Es gibt keine Sublokationen',
        locationsTitle: 'Standorte',
        edit: 'Bearbeiten',
        save: 'Speichern',
        added: 'Hinzugefügt',
        updated: 'Aktualisiert',
        add: 'Hinzufügen',
        reload: 'Neu laden',
        removed: 'Entfernt',
        confirm: 'Bestätigen',
        rollBack: 'Zurückrollen',
        images: 'Bilder',
        documents: 'Dokumente',
        download: 'Herunterladen',
        saved: 'Gespeichert',
        date: 'Datum',
        hour: 'Stunde',
        preview: 'Vorschau',
        data: 'Daten',
        attributes: 'Attribute',
        checkList: 'Checkliste',
        name: 'Name',
        type: 'Typ',
        status: 'Status',
        designation: 'Bezeichnung',
        symbol: 'Symbol',
        serialNumber: 'Seriennummer',
        registryNumber: 'Registrierungsnummer',
        machineNumber: 'Maschinennummer',
        udtNumber: 'UDT-Nummer',
        manufacturedYear: 'Jahr der Herstellung',
        manufacturer: 'Hersteller',
        supplier: 'Lieferant',
        mainSupplier: 'Hauptlieferant',
        attribute: 'Attribut',
        nameRequired: 'Name ist erforderlich',
        yearGreaterThan: 'Das Jahr muss größer sein als',
        location: 'Platz',
        fieldRequired: 'Dieses Feld ist erforderlich',
        description: 'Beschreibung',
        minimumQuantity: 'Mindestmenge',
        optimalQuantity: 'Optimale Menge',
        priority: 'Priorität',
        formatYYYY: 'Format YYYY',
        storageQuantity: 'Lagermenge',
        quantity: 'Menge',
        quantityGreaterThan: 'Die Menge muss größer sein als',
        machine: 'Maschine',
        tool: 'Werkzeug',
        order: 'Bestellung',
        required: 'Erforderlich',
        dateFormat: 'Datumsformat',
        selectDictionary: 'Wörterbuch auswählen',
        selectDictionaryValue: 'Wörterbuchwert auswählen',
        return: 'Rückgabe',
        parameters: 'Parameter',
        editCategory: 'Kategorie bearbeiten',
        addCategory: 'Neue Kategorie hinzufügen',
        changeColor: 'Farbe ändern',
        noColor: 'Keine Farbe',
        shift: 'Verschiebung',
        start: 'Start',
        end: 'Ende',
        shiftSchema: 'Schicht schema',
        shifts: 'Schichten',
        dictionary: 'Wörterbuch',
        subEntries: 'SubEntries',
        key: 'Schlüssel',
        value: 'Wert',
        moveUp: 'Aufwärts bewegen',
        moveDown: 'Abwärts bewegen',
        addLocation: 'Neuen Platz hinzufügen',
        editLocation: 'Platz bearbeiten',
        companiesDatabase: 'Firmenliste',
        flows: 'Durchfluss',
        read: 'Lesen',
        write: 'Schreiben',
        noImage: 'Kein Bild',
        email: 'E-mail',
        function: 'Funktion',
        active: 'Aktiv',
        notActive: 'Nicht aktiv',
        disabled: 'Deaktiviert',
        entryNumber: 'Eintragsnummer',
        issuedDate: 'Datum der Ausstellung',
        expiresDate: 'Verfallsdatum',
        move: 'Bewegen',
        separateForm: 'Getrennt von',
        separate: 'Getrennt',
        warehouse: 'Lagerung',
        actions: 'Aktionen',
        putInCurrentLocation: 'An den aktuellen Standort setzen',
        selectLocationFormRightMenu: 'Platz aus dem rechten Menü auswählen',
        showUnassignedItems: 'Nicht zugewiesene Posten anzeigen',
        separated: 'Getrennt',
        moved: 'Verschoben',
        categories: 'Kategorien',
        welcome: 'Willkommen',
        loginToSignaloCMMS: 'Anmelden bei Signalo CMMS',
        login: 'Anmeldung',
        loginByEmailAndPassword: 'Anmeldung per E-Mail und Passwort',
        loginByCode: 'Anmeldung nach Code',
        accessCode: 'Zugangscode',
        enterEmail: 'E-Mail eingeben',
        enterPassword: 'Passwort eingeben',
        enterCode: 'Code eingeben',
        userNotFound: 'Benutzer nicht gefunden',
        userNotActivated: 'Benutzer nicht aktiviert',
        userDisabled: 'Benutzer deaktiviert',
        wrongPassword: 'Falsches Passwort',
        locations: 'Plätze',
        pageNotFound: 'Seite nicht gefunden',
        group: 'Gruppe',
        yes: 'Ja',
        no: 'Nein',
        hourlyCost: 'Stündliche Kosten',
        price: 'Preis',
        newEntry: 'Neuer Eintrag',
        predictedFinishTime: 'Voraussichtliche Zeit für die Fertigstellung',
        archive: 'Archiv',
        costs: 'Kosten',
        companyManagement: 'Unternehmensleitung',
        companyData: 'Unternehmensdaten',
        supportedLanguages: 'Unterstützte Sprachen',
        en: 'Englisch',
        pl: 'Polnisch',
        es: 'Spanisch',
        de: 'Deutsch',
        it: 'Italienisch',
        fr: 'Französisch',
        ru: 'Russisch',
        uk: 'Ukrainisch',
        pt: 'Portugiesisch',
        tr: 'Türkisch',
        nl: 'Niederländisch',
        sr: 'Serbisch',
        defaultLanguage: 'Standardsprache',
        companyLogo: 'Firmenlogo',
        notificationsManagement: 'Verwaltung von Benachrichtigungen',
        category: 'Kategorie',
        today: 'Heute',
        month: 'Monat',
        week: 'Woche',
        day: 'Tag',
        close: 'Schließen',
        show: 'Anzeigen',
        rollBackFormalConfirmation: 'Formelle Bestätigung zurücknehmen',
        signUp: 'Registrieren',
        nameSurname: '@:common.USER_NAME_LABEL',
        users_name_label: 'Beschriftung vollständiger Name',
        userNameSurname: 'Vollständiger Name',
        userSurnameName: 'Nachname und Vorname',
        phone: 'Telefonnummer',
        password: 'Passwort',
        password_confirmation: 'Passwort wiederholen',
        unassignedItems: 'Nicht zugewiesene Posten',
        currency: 'Währung',
        general: 'Allgemein',
        timezone: 'Zeitzone',
        users: 'Benutzer',
        groups: 'Gruppen',
        productionLine: 'Produktionslinie',
        part: 'Teil',
        fittingParts: 'Passende Ersatzteile',
        workSchema: 'Arbeitsschema',
        workSchemas: 'Arbeitsschemata',
        holiday: 'Ferien',
        changePassword: 'Passwort ändern',
        showRest: 'Pause anzeigen',
        pageNotPermitted: 'Seite nicht erlaubt',
        waitingForActivation: 'Warten auf Aktivierung',
        editGroup: 'Gruppe bearbeiten',
        addGroup: 'Gruppe hinzufügen',
        reportProblem: 'Problem melden',
        describeOccuredIssue: 'Beschreiben Sie das aufgetretene Problem',
        markAllAsRead: 'Alle als gelesen markieren',
        unitType: 'Art der Einheit',
        unit: 'Einheit',
        unitPrice: 'Preis pro Einheit',
        notConfigured: 'Nicht konfiguriert',
        rowsPerPage: 'Zeilen pro Seite',
        rowsOfPage: 'auf',
        true: 'Wahr',
        false: 'Falsch',
        export: 'Exportieren',
        chooseFileFormat: 'Wählen Sie das Dateiforma',
        exported: 'Exportiert',
        terminals: 'Terminals',
        terminal: 'Terminal',
        selectEquipment: 'Ausrüstung auswählen',
        futureIssues: 'Zukünftige Ausgaben',
        scheduledOn: 'Geplant am',
        planned: 'Geplant',
        notPlanned: 'Nicht geplant',
        showOpenIssues: 'Offene Ausgaben anzeigen',
        pin: 'PIN',
        assignedEquipment: 'Zugewiesene Ausrüstung',
        terminalEquipment: 'Endgeräte',
        detach: 'Detach',
        attach: 'Attach',
        dashboardConfig: 'Dashboard-Konfiguration',
        addColumn: 'Spalte hinzufügen',
        addRow: 'Eine Zeile hinzufügen',
        removeRow: 'Zeile entfernen',
        registerTerminal: 'Terminal registrieren',
        issueGeneratesCost: 'Ausfallzeiten verursachen Kosten',
        selectColor: 'Wählen Sie eine Farbe',
        belowMinimum: 'Unter dem Minimum',
        belowOptimum: 'Unterhalb des Optimums',
        synchronization: 'Synchronisation',
        synchronizationExport: 'Export von Lagerteilen',
        synchronizationImport: 'Import von Lagerteilen',
        mapping: 'Zuordnung',
        returnTo: 'Zurückkehren nach',
        jobStatusses: 'Prozesse',
        hidden: 'Versteckt',
        editEvent: 'Ereignis bearbeiten',
        threeDays: '3 Tage',
        addEvent: 'Ereignis hinzufügen',
        plannedIssues: 'Geplante Aufgaben',
        currentService: 'Aktueller Dienstl',
        searchLocation: 'Suchplatz',
        all: 'Alle',
        unfinished: 'Unvollendet',
        numberOfIssues: 'Anzahl der Ausgaben',
        unknown: 'Unbekannt',
        partEntry: 'Teil (Eintrag)',
        foundItems: 'Gefundene Gegenstände',
        output: 'Output',
        copied: 'Kopiert',
        link: 'Link',
        authorizationRequired: 'Autorisierung erforderlich',
        authorizationRequiredDescriptionUser:
            'Sie verfügen leider nicht über eine ausreichende Genehmigung {value}. Bitte bitten Sie eine befugte Person, die Maßnahme zu genehmigen',
        authorizationRequiredTerminal:
            'Benutzen Sie Ihren Zugangscode, um den Vorgang zu autorisieren',
        showAll: 'Alles anzeigen',
        showClassicView: 'Klassische Ansicht anzeigen',
        externalSystems: 'Externe Systeme',
        noIssuesInCategory: 'Es gibt keine Probleme in dieser Kategorie.',
        numberOfIssuesInThisCategoryAndSubcategories:
            'Anzahl der Ausgaben in dieser Kategorie und Unterkategorien',
        numberOfIssuesInThisCategory:
            'Anzahl der Ausgaben in dieser Kategorie.',
        minBarcodeLength: 'Mindestlänge des Barcodes',
        currentPage: 'Aktuelle Seite',
        allPages: 'Alle Seiten',
        selectFormat: 'Format auswählen',
        provided_currency: 'Bereitgestellte Währung',
        provided_quantity: 'Bereitgestellte Menge',
        provided_unit: 'Bereitgestellte Einheit',
        provided_unit_price: 'Bereitgestellter Preis pro Einheit',
        unit_price: 'Einzelpreis',
        quantity_available: 'Verfügbare Menge',
        editBarcode: 'Barcode bearbeiten',
        crews: 'Ausrüstung',
        scheduleEventTypes: 'Geplante Ereignistypen',
        crew: 'Besatzung',
        scheduleEvent: 'Zeitplan-Ereignis',
        available: 'Verfügbar',
        'App\\Models\\Crew': 'Besatzung',
        'App\\Models\\User': 'Benutzer',
        'App\\Models\\Equipment': 'Ausrüstung',
        'App\\Models\\Part': 'Teil',
        Crew: 'Besatzung',
        User: 'Benutzer',
        Equipment: 'Ausrüstung',
        Part: 'Teil',
        scheduleEvents: 'Zeitplan für Ereignisse',
        event: 'Ereignis',
        user: 'Benutzer',
        availability: 'Verfügbarkeit',
        inheritColorFromParentIfCustomNotSet:
            'Erbt die Farbe vom übergeordneten Element, wenn keine eigene Farbe definiert wurde',
        pickFromAllParts: 'Aus allen Teilen auswählen',
        takeTool: 'Nimm das Werkzeug',
        returnTool: 'Rückholwerkzeug',
        personWhoTake: 'Person, die nimmt',
        personWhoReturn: 'Person, die zurückkehrt',
        takenAt: 'Nehmen Datum',
        takenBy: 'Sammler',
        toolIssuedBy: 'Disponent',
        commentTake: 'Kommentar beim Herunterladen',
        commentReturn: 'Kommentar zurückgeben',
        change: 'Ändern',
        onlyWithActiveRMIssues: 'Nur bei aktiven RM-Anforderungen',
        externalSystem: 'Externes System',
        rejectIssue: 'Ausgabe abgelehnt',
        withdrawIssueRejection: 'Abgelehnte Ausgabe zurückziehen',
        rejectionReason: 'Grund für die Ablehnung',
        rejected: 'Abgelehnt',
        showCrewMembers: 'Mitglieder der Besatzung',
        crewMembers: 'Besatzungsmitglieder',
        helpGroup: 'Dienst',
        partsTakenByUser: 'Vom Benutzer entnommene Teile',
        pickParts: 'Teileausbeute',
        selectPersonWhoTakes: 'Person auswählen, die nimmt',
        changePersonWhoTakes: 'Person ändern, die nimmt',
        quantityToPick: 'Zu wählende Menge',
        pickLocation: 'Abholplatz',
        selectPartsToPick: 'Wählen Sie die zu entnehmenden Teile aus',
        partSelected: 'Ausgewählter Teil',
        scanCodeOr: 'Code scannen oder',
        returnPart: 'ReturnPart',
        myTakenParts: 'Von mir heruntergeladene Teile',
        takenFromLocation: 'vom Platz genommen',
        takenQuantity: 'Entnommene Menge',
        providedUnit: 'Bereitgestellte Einheit',
        providedQuantity: 'Bereitgestellte Menge',
        selectFromStorage: 'Speicher auswählen',
        selectFromMyPickedParts: 'Wählen Sie aus meinen ausgewählten Teilen',
        exportProcessInProgressMessage:
            'Der Datenexport hat soeben begonnen. Wenn er abgeschlossen ist, erhalten Sie eine entsprechende Benachrichtigung mit einem Link zu der Datei',
        yourDocumentIsReady: 'Das Dokument ist fertig',
        rotateScreen: 'Bildschirm rotieren',
        addRule: 'Regel hinzufügen',
        editRule: 'Regel bearbeiten',
        summary: 'Zusammenfassung',
        onlyAvailableEmployees: 'Nur verfügbare Mitarbeiter zeigen',
        calculated_unit_price: 'Umgerechneter Preis pro Einheit',
        calculated_quantity: 'Umgerechnete Menge',
        next: 'Nächs',
        maintenanceMode: 'Wartungsmodus',
        applicationMayBeUnavailableForFewMinutes:
            'Die Anwendung kann für einige Minuten nicht verfügbar sein',
        appWillRefreshIn: 'Die Anwendung wird aktualisiert in',
        landscape: 'Querformat',
        portrait: 'Hochformat',
        orientation: 'Ausrichtung',
        format: 'Format',
        service: 'Bedienstete',
        leader: 'Vorarbeiter',
        defaultView: 'Standardansicht',
        view: 'Ansicht',
        oneDay: '1 Tag',
        object: 'Objekt',
        finished: 'Fertig',
        onlyNotFinished: 'Nur nicht fertig',
        generate: 'Generieren',
        error: 'Fehler',
        cell: 'Zelle',
        resolutionSummary: 'Ende Zusammenfassung',
        rejected_at: 'Ablehnungsdatum',
        rejected_by: 'Zurückgewiesen von',
        finishedByUser: 'Vervollständigt von',
        formalConfirmByUser: 'Formelle Bestätigung durch',
        formalConfirmAt: 'Datum der förmlichen Bestätigung',
        valueDeleted: '[Wert gelöscht]',
        hasNotPlannedIssue: 'Hat keine Ausgaben geplant',
        showInStorage: 'Im Speicher anzeigen',
        changeCode: 'Ändern Sie den Code',
        staffProfiles: 'Mitarbeiterprofile',
        profile: 'Profil',
        user_bug: 'Anwendungsfehler',
        user_kaizen: 'Änderungsvorschlag',
        changeSuggestions: 'Änderungsvorschläge',
        showOnlyCurrentlyAvailable: 'Nur aktuell verfügbar anzeigen',
        resetPassword: 'Passwort erinnern',
        forgotPassword: 'Passwort vergessen',
        resetPasswordMailSent:
            'Wir haben einen Link zum Setzen eines neuen Passworts an die angegebene E-Mail-Adresse gesendet',
        manyEventsThisTime: 'Viele Veranstaltungen in dieser Zeit',
        importScheduleCheckboxLabel:
            'Geplante Ereignisse im ausgewählten Monat für in der Datei aufgeführte Mitarbeiter löschen',
        inheritedEvent: 'Geerbtes Ereignis',
        inheritedModifiedEvent: 'Geändertes geerbtes Ereignis',
        equipmentId: 'Geräte ID',
        entryId: 'Eintrags ID',
        partId: 'Teil ID',
        suggestionsEmail: 'E-Mail, an die Änderungsvorschläge gesendet werden',
        meters: 'Zähler',
        scanCardToAuth:
            'Halten Sie die Karte an das Lesegerät oder geben Sie Ihren Zugangscode ein, um Ihre Identität zu bestätigen.',
        scanCard: 'Scannen Sie die Karte',
        cart: 'Austauschbox',
        emptyCardMessage:
            'Beginnen Sie mit dem Scannen von Produkten oder wählen Sie sie aus der Liste aus, um sie der Handelsbox hinzuzufügen.',
        terminalMode: 'Terminaltyp',
        askPermittedUserToConfirmPartsExchange:
            'Bitten Sie die autorisierte Person, die Freigabe des Teils zu bestätigen, indem Sie die Karte scannen oder den Code eingeben.',
        partsIssued: 'Teile freigegeben',
        areYouSureAboutCancel:
            'Sind Sie sicher, dass Sie die Aktion abbrechen möchten?',
        areYouSureAboutRemoveFromCart:
            'Sind Sie sicher, dass Sie das Produkt aus dem Austauschbox entfernen möchten?',
        standard: 'Standard',
        idNumber: 'Identifikationsnummer',
        takeParts: 'Teile entnehmen',
        returnParts: 'Teile zurückgeben',
        quantityToReturn: 'Zurückzugebende Menge',
        partsPendingApproval: 'Teile in Bearbeitung',
        partsReturned: 'Teile zurückgegeben',
        partsAddedToPendingApproval: 'Teile zur Genehmigung hinzugefügt',
        approvePartsReturn: 'Genehmigen Sie die Rückgabe von Teilen',
        partReturnApproved: 'Teilrückgabe genehmigt',
        partUsage: 'Teilnutzung',
        awaitsReturn: 'Warten auf Rückgabe',
        entrySelection: 'Eintragsauswahl',
        correctQuantity: 'Menge korrigieren',
        quantityCorrection: 'Mengenkorrektur',
        entrySelectionAsc: 'Eintragsauswahl (aufsteigend)',
        entrySelectionDesc: 'Eintragsauswahl (absteigend)',
        metersSettings: 'Zähler Einstellungen',
        countableFields: 'Zählbare Felder',
        equipmentTypes: 'Gerätetypen',
        fieldName: 'Feldname',
        countableField: 'Zählbares Feld',
        partsStatusTaken: 'Teile entnommen',
        rejectPartsReturn: 'Teilrückgabe ablehnen',
        areYouSureAboutRejectPartsReturn:
            'Sind Sie sicher, dass Sie die Teilrückgabe ablehnen möchten?',
        partReturnRejected: 'Teilrückgabe abgelehnt',
        counterFields: 'Zählerfelder',
        counterName: 'Zählername',
        counterFieldName: 'Zählerfeldname',
        counterId: 'Zähler ID',
        counterUUID: 'Zähler UUID',
        counterPickerPlaceholder: 'Wählen Sie einen Zähler aus',
        pickFromPartsList: 'Wählen Sie aus der Teilliste aus',
        changeLocation: 'Standort ändern',
        isPartStorageRoot: 'Teil des Speichers',
        isStorageRoot: 'Teil des Speichers',
        areYouSureAboutArchiveIssue:
            'Sind Sie sicher, dass Sie die Ausgabe archivieren möchten?',
        ganttChart: 'Gantt-Diagramm',
        table: 'Tabelle',
        fittingEquipment: 'Passendes Gerät',
        notAssigned: 'Nicht zugewiesen',
        counters: 'Zähler',
        machineHourlyCostNotProvided:
            'Der stündliche Maschinenkostensatz wurde nicht angegeben',
        eventTypesMightBeDefinedHere:
            'Ereignistypen können hier definiert werden',
        toolsTakenByUser: 'Werkzeuge vom Benutzer entnommen',
        predictedReturnDate: 'Voraussichtliches Rückgabedatum',
        estimatedTimeOfUsingToolInHours:
            'Geschätzte Nutzungsdauer des Werkzeugs (in Stunden)',
        showOnlyAvailable: 'Nur verfügbare anzeigen',
        toolTakeLog: 'Werkzeugentnahme-Protokoll',
        takeDate: 'Entnahmedatum',
        returnDate: 'Rückgabedatum',
        personWhoAcceptReturn: 'Person, die die Rückgabe akzeptiert',
        statisticStrategy: 'Barrierefreiheitsstrategie',
        EquipmentPlannedStrategy: 'Laut Arbeitsplan',
        EquipmentConstantAvailabilityStrategy: 'Immer verfügbar',
        actionAfterIssueFinish: 'Aktion nach Abschluss der Ausgabe',
        enabled: 'Aktiviert',
        categoryOfNewIssue: 'Kategorie der neuen Ausgabe',
        workNotStarted: 'Arbeit nicht begonnen',
        colorInherited: 'Farbe geerbt',
        abcClassification: 'ABC-Klassifizierung',
        xyzClassification: 'XYZ-Klassifizierung',
        classification: 'Klassifizierung',
        filters: 'Filter',
        wipeFilters: 'Filter löschen',
        takePartsFromUser: 'Teile vom Benutzer entnehmen',
        selectPersonWhoReturns:
            'Wählen Sie die Person aus, die die Teile zurückgibt',
        changePersonWhoReturns:
            'Ändern Sie die Person, die die Teile zurückgibt',
        returnLocation: 'Rückgabeort',
        returnQuantity: 'Rückgabemenge',
        globalSettings: 'Globale Einstellungen',
        delimiter: 'Trennzeichen',
        fieldRules: 'Feldregeln',
        fieldValue: 'Feldwert',
        user_email_regex: 'E-Mail-Regex',
        barcodeLength: 'Barcode-Länge',
        partLine: 'Teilzeile',
        partFamily: 'Teilfamilie',
        partBatch: 'Teilcharge (batch)',
        testValueValid: 'Testwert gültig',
        testValueNotValid: 'Testwert ungültig',
        canBePicked: 'Kann gewählt werden',
        issue_criticality: 'Probleme – Kritikalität',
        issue_help_webapp: 'Probleme – Unterstützung erforderlich (App)',
        issue_help_terminal: 'Probleme – Unterstützung erforderlich (Terminal)',
        issue_kind: 'Meldungsart',
        HIDE: 'Verstecken',
        SHOW: 'Zeigen',
        REQUIRE: 'Erfordern',
        propagateValues: 'Wertverbreitung',
        archived: 'Archiviert',
        singleEvent: 'Einzeleintritt',
        seriesOfEvents: 'Eine Reihe von Einträgen',
        omitWeekends: 'Vermeiden Sie Wochenenden',
        allEntriesSaved: 'Alle Einträge wurden hinzugefügt',
        parentCategory: 'Eltern-Kategorie',
        first_day_of_week: 'Erster Tag der Woche',
        assignEmployee: 'Weisen Sie einen Mitarbeiter zu',
        addNewMachine: 'Fügen Sie eine neue Maschine hinzu',
        addNewTool: 'Fügen Sie ein neues Werkzeug hinzu',
        parentLocation: 'Übergeordneter Standort',
        equipmentStates: 'Gerätezustände',
        equipmentState: 'Zustand der Ausrüstung',
        fontColor: 'Schriftfarbe',
        downtime: 'Ausfallzeit',
        setState: 'Status festlegen',
        from: 'Aus',
        to: 'Bis',
        inProgress: 'Während',
        noEntries: 'Keine Beiträge',
        products: 'Produkte',
        product: 'Produkt',
        setCurrentProduct:
            'Legen Sie das aktuell in Produktion befindliche Produkt fest',
        commentable: 'Möglichkeit zur Kommentierung',
        allows_state_update:
            'Statusänderung während des Kommentars erforderlich',
        undescribed: 'Unbeschreiblich',
        state: 'Zustand',
        productionMonitor: 'Produktionsmonitor',
        undescribedStates: 'Unbeschriebene Zustände',
        toolsPicker: 'Abholung/Rückgabe von Werkzeugen',
        toolsGroups: 'Werkzeuggruppen',
        of: 'mit',
        image: 'Foto',
        selectTools: 'Wählen Sie Werkzeuge',
        takeTools: 'Laden Sie Tools herunter',
        returnTools: 'Geben Sie die Werkzeuge zurück',
        askPermittedUserToConfirmToolsExchange:
            'Bitten Sie die autorisierte Person, die Ausgabe/Rückgabe der Werkzeuge durch Scannen der Karte oder Eingabe des Codes zu bestätigen.',
        toolsPendingApproval:
            'Zurückgesendete Werkzeuge warten auf Genehmigung',
        production_monitor_visible_columns:
            'Produktionsmonitor – sichtbare Spalten',
        details: 'Einzelheiten',
        otherData: 'Andere Daten',
        showAllTools: 'Alle Werkzeuge anzeigen',
        allTools: 'Alle Werkzeuge',
        approveToolReturn: 'Akzeptieren Sie die Rückgabe des Werkzeugs',
        rejectToolReturn: 'Lehnen Sie die Rückgabe des Werkzeugs ab',
        areYouSureAboutRejectToolReturn:
            'Sind Sie sicher, dass Sie die Rückgabe des Werkzeugs ablehnen möchten?',
        areYouSureAboutAcceptToolReturn:
            'Möchten Sie die Rückgabe des Werkzeugs wirklich bestätigen?',
        toolReturnApproved: 'Werkzeugrückgabe genehmigt',
        toolReturnRejected: 'Werkzeugrückgabe abgelehnt',
        toReturn: 'Zurückgeben',
        toolsCart: 'Austauschbox - Werkzeuge',
        toolsIssued: 'Tools heruntergeladen',
        toolsAddedToPendingApproval:
            'Die Werkzeuge wurden zur Warteliste für die Rücksendegenehmigung hinzugefügt',
        toolsReturned: 'Werkzeuge zurückgegeben',
        mainShift: 'Hauptschicht',
        scanCode: 'Scannen Sie den Code',
        codeRecognized: 'Code erkannt',
        moveAllEntriesFromCurrentLocation:
            'Alle Einträge von diesem Ort verschieben',
        newAwaitingValue: 'Neuer Wert wartet auf Genehmigung',
        newValuesArePendingConfirmation:
            'Die Änderungen warten auf ihre Genehmigung',
        changeRequests: 'Änderungswünsche',
        currentValues: 'Aktuelle Werte',
        requestedValues: 'Werte, die sich ändern müssen',
        removeRequestIsWaitingForApprove:
            'Die Löschung muss noch genehmigt werden',
        imageRemoveRequestLabel: 'Ein Foto löschen',
        areYouSureAboutCancelChangeRequest:
            'Sind Sie sicher, dass Sie die Änderungsanforderung abbrechen möchten?',
        document: 'Dokumentieren',
        rename: 'Umbenennen',
        openInEditor: 'Im Editor öffnen',
        unsavedChangesMayBeLost:
            'Nicht gespeicherte Änderungen gehen möglicherweise verloren',
        location_name_regex: 'Standortnamensregel',
        employeesWorkingCount:
            'Anzahl der Mitarbeiter, die an diesem Thema arbeiten',
        always: 'Stets',
        indexes: 'Indizes',
        indexesEntriesTypes: 'Eintragsarten',
        indexEntry: 'Indexeintrag',
        index: 'Index',
        pickIndex: 'Wählen Sie einen Index aus',
        report: 'Bericht',
        reportGenerationInProgress: 'Der Bericht wird generiert',
        production_monitor_equipment_state_change:
            'Ändern des Maschinenstatus über den Produktionsmonitor',
        part_entries_auto_barcode_generation:
            'Automatische Barcode-Generierung für Teileinträge',
        new_issue_equipment_kind: 'Art der Ausrüstung in der neuen Meldung',
        manageVisibleColumns: 'Passen Sie die Sichtbarkeit der Spalte an',
        columnName: 'Spaltenname',
        visible: 'Sichtbar',
        partStorageRootWarningMessage:
            'Dieser Standort wird als Hauptlagerstandort für Teile festgelegt. Das Lager und das Auswahlfenster für den Lagerstandort ermöglichen Ihnen nur die Auswahl von Einträgen, die sich an diesem Standort befinden',
        entriesLocation: 'Ort der Einträge',
        cloneIssue: 'Klon',
        machinesMap: 'Maschinenkarte',
        doYouWantToAddNewMarker: 'Möchten Sie hier einen neuen Tag hinzufügen?',
        areYouSureAboutRemoveMarker:
            'Möchten Sie dieses Tag wirklich entfernen?',
        plants: 'Fabrikanlagen',
        plant: 'Fabrik',
        buildings: 'Gebäude',
        building: 'Gebäude',
        floors: 'Böden',
        floor: 'Boden',
        map: 'Karte',
        areYouSureAboutMoveMarker:
            'Sind Sie sicher, dass Sie diese Markierung verschieben möchten?',
        marker: 'Marker',
        addNewMarkerTooltipMessage:
            'Um eine neue Markierung hinzuzufügen, klicken Sie mit der rechten Maustaste auf die Karte.',
        takenTools: 'Heruntergeladene Tools',
        askPermittedUserToConfirmToolExchange:
            'Bitten Sie die autorisierte Person, die Ausgabe/Rückgabe des Werkzeugs durch Scannen der Karte oder Eingabe des Codes zu bestätigen.',
        warnDays: 'Benachrichtigung vor Ablauf (Tage)',
        licenseType: 'Lizenz-Typ',
        licenseGroup: 'Lizenzgruppe',
        toolsCartTerminalRequireApproveOnToolReturn:
            'Bei Rückgabe heruntergeladener Tools ist eine Bestätigung/Ablehnung erforderlich',
        attachments: 'Anhänge',
        attachment: 'Anhang',
        searchInCurrentLocation: 'Suchen Sie an Ihrem aktuellen Standort',
        icon: 'Symbol',
        nfc: 'NFC',
        rfid: 'RFID',
        other: 'Andere',
        tags: 'Karten / Stichworte',
        tag: 'Karte / Etikett',
        userPinCode: 'Kartenbenutzer-PIN',
        pin_code_field_type: 'Pin-Code-Typ',
        alphanumeric: 'Alphanumerisch',
        numeric: 'Numerisch',
        showCodeOwnerNameDuringParing:
            'Beim Koppeln mit Karte/Tag den Namen des Codebesitzers anzeigen',
        showUsernameInCart: 'Benutzernamen im Warenkorb anzeigen',
        flag: 'Flagge',
        flags: 'Flaggen',
        manageFlags: 'Flaggen verwalten',
        skills: 'Fähigkeiten',
        skill: 'Fähigkeit',
        skillRank: 'Bewertung',
        selectToolsByType: 'Wählen Sie Werkzeuge nach Typ aus',
        openToolsPickerOnCartInit:
            'Öffnen Sie automatisch das Werkzeugauswahlfenster, wenn Sie zum Warenkorb gehen.',
        toolsTypes: 'Werkzeugtypen',
        workOrderTemplates: 'Arbeitsauftragsvorlagen',
        workOrderTemplate: 'Arbeitsauftragsvorlage',
        workOrders: 'Arbeitsanweisungen',
        workOrder: 'Arbeitsauftrag',
        employee: 'Mitarbeiter',
        workOrderCreatedBy: 'In Autrag gegeben von',
        print: 'Drucken',
        issueCreated: 'Ein Ticket wurde erstellt',
        newIssue: 'Neuer Bericht',
        sampleButtonPlaceholder: 'Beispielschaltfläche',
        preferences: 'Präferenzen',
        buttonsSize: 'Knopfgröße',
        defaultValue: 'Standardwert',
        warning: 'Warnung',
        allowedIssuesCategories: 'Zulässige Berichtskategorien',
        hideAbilityToAssignEmployeesToIssue:
            'Blenden Sie die Möglichkeit aus, Mitarbeiter einem Problem zuzuordnen',
        issuesWithRelatedCategories: 'Unterkategorien einschließen',
        issuesLimit: 'Begrenzung der Probleme',
        issuesLimits: 'Probleme – Grenzen',
        closeLocker: 'Schließen Sie den Schrank',
        closeLockerMessage: 'Um fortzufahren, schließen Sie den Schrank',
        closedTooFast: 'Haben Sie zu schnell geschlossen?',
        doYouWantToReopenLocker: 'Möchten Sie das Schließfach wieder öffnen?',
        reopen: 'Wieder öffnen',
        quit: 'Beenden',
        hiddenFields: 'Versteckte Felder',
        defaultValues: 'Standardwerte',
        paddingBottom: 'Leerer Raum unten',
        allVisibleFieldsRequired:
            'Alle sichtbaren Felder müssen ausgefüllt sein',
        emailConfirmation: 'Bestätigung der E-Mail-Adresse',
        user_active_after_email_confirm:
            'Das Benutzerkonto wird nach Bestätigung Ihrer E-Mail-Adresse automatisch aktiviert',
        phone_change_requires_confirmation_code:
            'Das Ändern der Telefonnummer erfordert eine Bestätigung mit einem Code',
        toolsLocation: 'Werkzeugstandort',
        manageFilters: 'Filter verwalten',
        erase: 'löschen',
        can_pick_undescribed_equipment_state:
            'Möglichkeit, einen unbeschreiblichen Zustand zu wählen',
        helpdesk: 'Beratungsstell',
        measureTypes: 'Arten von Messungen',
        measureType: 'Messart',
        measurable: 'Messbarer Indikator',
        measurables: 'Messbare Indikatoren',
        measurements: 'Messung',
        measurement: 'Messung',
        measuredAt: 'Messdatum',
        employeeNumber: 'Mitarbeiternummer',
        lastLocation: 'Letzter Standort',
        readonly: 'Schreibgeschützt',
        equipment: 'Ausrüstung',
        conditions: 'Bedingungen',
        permission: 'Erlaubnis',
        formula: 'Formel',
        notification: 'Benachrichtigung',
        transition: 'Übergang',
        fillValuesToChangeState:
            'Vervollständigen Sie die Werte, um den Status zu ändern.',
        loginTo: 'Einloggen in',
        appName: 'Signalo CMSS',
        manageState: 'Status verwalten',
        webMessage: 'Web-Nachricht',
        terminalId: 'Terminal-ID',
        operatorId: 'Betreiber-ID',
        newConversation: 'Neues Thema',
        application: 'App',
        phones: 'Telefonnummern',
        message: 'Nachricht',
        channels: 'Kanäle',
        url: 'URL',
        kind: 'Rodzaj',
        forkfleetConfigId: 'Forkfleet Konfiguration',
        create: 'Erstellen',
        terminate: 'Beenden',
        recreateIssue: 'Erstellen Sie das Ticket neu',
        ordinal: 'Ordnungswert',
        parameterName: 'Parametername',
        backgroundColor: 'Hintergrundfarbe',
        columns: 'Anzahl der Spalten',
        colspan: 'Breite (Spalten)',
        fill: 'Vollständig',
        duplicate: 'Duplikat',
        loginAsThisUser: 'Melden Sie sich als dieser Benutzer an',
        partLot: 'Serie',
        minBrowserVersion: 'Mindestbrowserversion erforderlich',
        currentVersion: 'Aktuelle Version',
        equipment_planned_completed_percent_target:
            'Prozentuales Ziel für die Umsetzung geplanter Inspektionen',
        autoTranslate: 'Automatische Übersetzung',
        auto_translation: 'Automatische Übersetzung',
        awaitingAutoTranslation: 'Warten auf automatische Übersetzung',
        signaturePinTagConfirmationText1:
            'Mit @:common.PIN_CODE_LABEL unterschreiben',
        signaturePinTagConfirmationText2: 'oder scannen Sie Ihre Karte.',
        signedWithPinCode: 'mit @:common.PIN_CODE_LABEL signiert',
        signedWithTAG: 'signiert mit Karte/Tag',
        trusted_device_code_login_users_limit:
            'Schnellanmeldung – Anzahl der angezeigten Benutzer',
        display_fields_issue_created_at:
            'Felder anzeigen - Erstellung eines Berichts',
        docs_sidebar_hidden_by_default: 'Dokumente – versteckte Seitenleiste',
        issue: 'Meldung',
        control: 'Kontrolle',
        compatibility: 'Kompatibilität',
        replacement: 'Ersatz',
        backCompatibility: 'Beidseitige Kompatibilität',
    },
    placeholders: {
        part: 'Wählen Sie ein Teil...',
        nameSurname: '@:common.USER_NAME_LABEL',
        phone: 'Telefonnummer...',
        password: 'Passwort...',
        password_confirmation: 'Passwort wiederholen...',
        email: 'E-Mail...',
    },
    auth: {
        notYourAccountQuestion: 'Nicht Ihr Konto?',
    },
    signup: {
        registered: 'Registriert!',
        emailConfirmed: 'Die E-Mail wurde bestätigt.',
        registered_info:
            'Bitten Sie Ihren Vorgesetzten, Ihr Konto zu aktivieren',
        confirmEmailAddress:
            'Zwei Benutzer haben ein Konto erstellt, klicken Sie auf den Link mit Ihrer E-Mail-Adresse und geben Sie die gewünschte Adresse ein.',
        tokenNotFoundError:
            'Die E-Mail wurde bereits bestätigt oder der Bestätigungslink ist ungültig.',
    },
    paramTypes: {
        text: 'Text',
        note: 'Notiz',
        integer: 'Ganzzahl',
        decimal: 'Dezimal',
        date: 'Datum',
        time: 'Stunde',
        datetime: 'Datum und Uhrzeit',
        color: 'Farbe',
        Symbol: 'Symbol',
        boolean: 'Nein / Ja',
        signature: 'Unterschrift',
    },
    tableHeaders: {
        id: 'ID',
        name: 'Name',
        path: 'Pfad zur Datei',
        category: 'Kategorie',
        equipment: 'Ausrüstung',
        criticality: 'Kritikalität',
        status: 'Status',
        created: 'Erstellt',
        createdBy: 'Erstellt von',
        fp: 'FP',
        type: 'Typ',
        designation: 'Bezeichnung',
        symbol: 'Symbol',
        serialNumber: 'SerialNumber',
        registryNumber: 'Registrierungsnummer',
        udtNumber: 'UDT-Nummer',
        manufacturedYear: 'Jahr der Herstellung',
        actions: 'Aktionen',
        title: 'Titel',
        data: 'Datum',
        archived: 'archiviert',
        manufacturerSymbol: 'Symbol des Herstellers',
        min: 'Min',
        opt: 'Opt',
        quantity: 'Menge',
        priority: 'Priorität',
        price: 'Preis',
        kind: 'Art',
        description: 'Beschreibung',
        default: 'Standard',
        warning: 'Warnung',
        problem: 'Problem',
        fixing: 'Festsetzung',
        changeOrder: 'Änderungsauftrag',
        required: 'Erforderlich',
        icon: 'Icon',
        color: 'Farbe',
        subCategories: 'Unterkategorien',
        barCode: 'Strichcode',
        subLocations: 'SubLocations',
        categories: 'Kategorien',
        image: 'Bilder',
        nameSurname: '@:common.USER_NAME_LABEL',
        email: 'E-Mail',
        phone: 'Telefonnummer',
        function: 'Funktion',
        department: 'Abteilung',
        accountStatus: 'Kontostatus',
        shift: 'Schicht',
        licenseNumber: 'Lizenznummer',
        issuedDate: 'Ausgabedatum',
        expiresDate: 'Auslaufdatum',
        entries: 'Einträge',
        entryNumber: 'Eintragsnummer',
        buyPrice: 'Kaufpreis',
        currentLocationQuantity: 'Menge am aktuellen Standort',
        group: 'Gruppe',
        string: 'Text',
        integer: 'Ganzzahl',
        toolsGroup: 'Werkzeuggruppe',
        manufacturer: 'Hersteller',
        shortName: 'Kurzname',
        locationName: 'Ortsname',
        subLocationsQuantity: 'Menge der Unterstandorte',
        isWorkingOnIssue: 'Arbeitet an einer Ausgabe',
        openIssues: 'Offene Fragen',
        notificationDate: 'Datum der Benachrichtigung',
        titleAndDescription: 'Titel und Beschreibung',
        read: 'Gelesen',
        created_at: 'Erstellt',
        received_at: 'Empfangen',
        started_at: 'Angefangen',
        arrived_at: 'Angekommen',
        finished_at: 'Beendet',
        country: 'Land',
        city: 'Stadt',
        progress: 'Fortschritt',
    },
    searchConfig: {
        id: 'Id',
        name: 'Name...',
        shortName: 'Kurzname...',
        country: 'Land...',
        email: 'E-Mail...',
        group: 'Gruppe...',
        geplant: 'Geplant',
        category: 'Kategorie...',
        object: 'Objekt...',
        criticality: 'Kritikalität',
        fp: 'FP',
        type: 'Typ...',
        designation: 'Bezeichnung...',
        symbol: 'Symbol...',
        serialNumber: 'Seriennummer...',
        registryNumber: 'Registriernummer...',
        udtNumber: 'UDT-Nummer...',
        manufacturedYear: 'Herstellungsjahr...',
        manufacturerSymbol: 'Herstellerkennzeichen...',
        priority: 'Priorität...',
        quantity: 'Menge...',
        buyPrice: 'Einkaufspreis...',
        kind: 'Art...',
        toolsGroup: 'Werkzeuggruppe...',
        function: 'Funktion...',
        department: 'Abteilung...',
        status: 'Status...',
        nameSurname: '@:common.USER_NAME_LABEL',
        phone: 'Telefon...',
        barCode: 'Strichcode',
        color: 'Farbe...',
        icon: 'Symbol...',
        machine: 'Maschine...',
        tool: 'Werkzeug...',
        urgentAndOutdated: 'Dringend und veraltet',
        urgent: 'Dringend',
        expired: 'Abgelaufen',
        manufacturer: 'Hersteller',
    },
    errors: {
        error: 'Ein Fehler ist aufgetreten',
        wrongEmail: 'Ungültige E-Mail',
        wrongPasswordLength:
            'Das Passwort muss mindestens 8 Zeichen lang sein.',
        wrongCodeLength: 'Der Code muss mindestens 5 Zeichen lang sein.',
        passwordsNotMatch: 'Passwörter stimmen nicht überein',
        codesNotMatch: 'Codes stimmen nicht überein',
        codeAlreadyInUse: 'Code wird bereits verwendet',
        expiresDateLowerThanIssued:
            'Das Ablaufdatum kann nicht niedriger als das Ausgabedatum sein.',
        cannotMoveToTheSameLocation:
            'Kann nicht an denselben Standort verschoben werden.',
        locationRequired: 'Standort erforderlich.',
        putQuantity: 'Menge zur Trennung angeben.',
        valueGreaterThanQuantity: 'Der Wert ist größer als die Gesamtmenge.',
        wholeCannotBeDistinguished: 'Ganzes kann nicht unterschieden werden.',
        yearMustBeGreaterThan: 'Das Jahr muss größer sein als ',
        passwordConfirmationNotMatch: 'Passwörter stimmen nicht überein',
        mustBeInteger: 'Wert muss eine Ganzzahl sein',
        valueTooLong: 'Wert zu lang',
        wrongPhoneNumber: 'Falsche Telefonnummer',
        phoneNumberAlreadyTaken: 'Telefonnummer bereits vergeben',
        emailAlreadyTaken: 'E-Mail bereits vergeben',
        notFound: 'Nicht gefunden',
        sessionExpired: 'Sitzung abgelaufen',
        tenantNotFound:
            'Die angegebene Konfiguration existiert nicht. Überprüfen Sie die Website-Adresse und versuchen Sie es erneut.',
        selectEquipmentTypeToConfigureParameters:
            'Wählen Sie den Gerätetyp zur Konfiguration der Parameter aus.',
        noParametersToConfigure:
            'Der ausgewählte Gerätetyp hat keine zu konfigurierenden Parameter.',
        terminalAlreadyRegistered: 'Terminal bereits registriert.',
        invalidPin: 'Ungültiger PIN',
        eventCollision:
            'Die Zeit des von Ihnen hinzuzufügenden Ereignisses überschneidet sich mit der Zeit eines anderen Ereignisses.',
        mustStartWithSlash: 'Muss mit / beginnen',
        mustBeBetween: 'Wert muss zwischen liegen:',
        minLength: 'Minimale Länge: ',
        maxLength: 'Maximale Länge: ',
        invalidInputForCodeType:
            'Ungültige Eingabe für den ausgewählten Codetyp',
        invalidCodeOrNoPermission:
            'Der Code ist ungültig oder Sie haben nicht die erforderlichen Berechtigungen, um diese Aktion auszuführen.',
        endDateLowerThanStart:
            'Das Enddatum darf nicht früher als das Startdatum sein',
        iconAlreadyTaken: 'Icon ist bereits vergeben',
        notEnoughQuantityInStorage: 'Nicht ausreichende Menge im Lager.',
        valueTooLow: 'Wert zu niedrig',
        valueTooHigh: 'Wert zu hoch',
        maxAvailableQuantity: 'Höchstzahl',
        someFilesRejectedDueToSize:
            'Einige Dateien wurden aufgrund ihrer Größe abgelehnt. Maximale Größe einer einzelnen Datei:',
        cameraDeviceNotFound: 'Kameragerät nicht gefunden',
        cameraPermissionDenied:
            'Der Zugriff auf die Gerätekamera wurde in den Website-Einstellungen blockiert. Setzen Sie die Website-Einstellungen zurück und erlauben Sie die Verwendung der Kamera.',
        passwordResetLinkExpired:
            'Der Link zum Zurücksetzen des Passworts ist abgelaufen',
        noInternetConnection: 'Keine Internetverbindung',
        minimum: 'Minimum',
        mustBeGreaterThan: 'Muss größer sein als',
        noEventTypesDefined: 'Keine Ereignistypen definiert',
        regexPatternDelimiterError:
            'Das Trennzeichen muss mit einem \\ weggelassen werden, z. B: \\/',
        emailNotMatchPatternDefiniedInTenant:
            'Die E-Mail-Adresse entspricht nicht dem im Mandanten definierten Muster',
        partMustHaveEntriesToCorrectQuantity:
            'Das Teil muss über Einträge verfügen, um den Zustand zu korrigieren.',
        fileTooBigToOpenWillBeDownloaded:
            'Die Datei ist zu groß zum Öffnen. Die Datei wird auf Ihr Gerät heruntergeladen.',
        entriesNotSavedDueToCollision:
            'Einträge wurden nicht hinzugefügt. Zum ausgewählten Zeitpunkt sind bereits Veranstaltungen vorhanden.',
        someEntriesWereRejected:
            'Einige Einträge wurden nicht hinzugefügt, da sie mit anderen Veranstaltungen in Konflikt stehen.',
        toolAlreadyInCart:
            'Dieses Werkzeug befindet sich bereits in Ihrem Warenkorb',
        toolAlreadyTaken: 'Dieses Tool wurde bereits veröffentlicht',
        toolIsNotTaken: 'Dieses Tool wurde nicht veröffentlicht',
        documentNotEditable: 'Dieses Dokument kann nicht bearbeitet werden',
        notPermissionsToEditDocument:
            'Sie sind nicht berechtigt, dieses Dokument zu bearbeiten',
        cannotLoadDocumentNoPath:
            'Das Dokument konnte nicht geladen werden – ungültige Adresse',
        locationNameNotMatchPatternDefiniedInTenant:
            'Der Name entspricht nicht der in den Einstellungen definierten Regel',
        noFloorLayoutProvided: 'Der Boden hat keine definierte Karte',
        maximum: 'Höchster Wert',
        allLanguagesRequired: 'Vervollständigen Sie den Wert in allen Sprachen',
        noItemsAvailable: 'Keine Artikel verfügbar',
        noFlagsConfigured: 'Keine Flags definiert',
        noSkillsDefined: 'Keine Fähigkeit definiert',
        someoneIsWorkingOnIssue:
            'Nicht alle Mitarbeiter haben ihre Arbeit an diesem Bericht abgeschlossen. Sind Sie sicher, dass Sie es beenden möchten?',
        fillAllRequiredParameters:
            'Vervollständigen Sie alle erforderlichen Parameter.',
        issueLimitError:
            'Das Limit der Probleme in der ausgewählten Kategorie wurde erreicht für: ',
        issueLimitError2: 'und Funktionen: ',
        duplicateError: 'Dieser Wert existiert bereits',
        versionErrorMessage:
            'Ihre letzten Änderungen wurden nicht gespeichert, weil jemand anderes gleichzeitig Änderungen vorgenommen hat. Aktualisieren Sie die Seite und versuchen Sie es erneut.',
        firstLoginTrustedDeviceError:
            'Für die erste Anmeldung auf einem neuen Gerät ist die Eingabe Ihrer E-Mail-Adresse und Ihres Passworts erforderlich.',
        tagNotFound: 'Karte/Tag nicht erkannt',
        noChecklistsAssignedToControl:
            'Der ausgewählten Kontrolle ist keine Checkliste zugeordnet',
        lockerNotConnected: 'Schloss ist nicht verbunden',
        lockerNotAvailable: 'Schloss ist nicht verfügbar',
        noChecklistItemsError: 'Checkliste ist nicht konfiguriert',
    },
    navDrawer: {
        dashboard: 'Übersicht',
        issues: 'Probleme',
        timetable: 'Zeitplan',
        machines: 'Maschinen',
        tools: 'Werkzeuge',
        parts: 'Teile',
        storage: 'Lager',
        staff: 'Mitarbeiter',
        configuration: 'Konfiguration',
        notes: 'Notizen',
        notifications: 'Benachrichtigungen',
        profile: 'Profil',
        supervision: 'Überwachung',
    },
    barcodeScanner: {
        barCode: 'Barcode',
        id: 'ID',
    },
    categoryPicker: {
        categoryPlaceholder: 'Kategorie...',
        selectCategory: 'Kategorie auswählen',
        noSubcategories: 'Keine Unterkategorien',
    },
    companies: {
        addCompany: 'Firma hinzufügen',
        editCompany: 'Firma bearbeiten',
        fullName: 'Vollständiger Name',
        shortName: 'Kurzname',
        group: 'Gruppe',
        country: 'Land',
        city: 'Stadt',
        street: 'Straße',
        postCode: 'Postleitzahl',
        phone: 'Telefon',
        email: 'E-Mail',
        website: 'Website',
        NIP: 'NIP',
        REGON: 'Nationales Handelsregister',
        active: 'Aktiv',
        nameRequired: 'Name ist erforderlich',
        shortNameRequired: 'Name ist erforderlich',
    },
    issues: {
        tookAt: 'Getroffen um',
        changeHistory: 'Änderungsverlauf',
        load: 'Laden',
        date: 'Datum',
        createdBy: 'Erstellt von',
        action: 'Aktion',
        data: 'Daten',
        created: 'Erstellt',
        updated: 'Aktualisiert',
        deleted: 'Gelöscht',
        restored: 'Wiederhergestellt',
        issues: 'Probleme',
        issue: 'Problem',
        by: 'von',
        name: 'Name',
        applicantsDescription: 'Beschreibung des Antragstellers',
        accidentDescription: 'Unfallbeschreibung',
        jobDescription: 'Aufgabenbeschreibung',
        jobSummary: 'Zusammenfassung der Aufgabe',
        category: 'Kategorie',
        status: 'Status',
        noFlow: '[Kein Ablauf]',
        equipment: 'Ausrüstung',
        criticality: 'Kritikalität',
        hour: 'Stunde',
        formalConfirmation: 'Formelle Bestätigung',
        formalConfirmationShortcut: 'FB',
        formalConfirmationRequired: 'FB erforderlich',
        parameter: 'Parameter',
        value: 'Wert',
        addIssue: 'Problem hinzufügen',
        expectedCompletionDate: 'Geplanter Abschlussdatum',
        issueDescription: 'Problem Beschreibung',
        partsUsage: 'Verwendung von Teilen',
        assignedEmployees: 'Zugewiesene Mitarbeiter',
        requiredHelp: 'Benötigte Hilfe',
        returnParts: 'Teil zurückgeben',
        confirmUnassignEmployeeWhoTakenIssue:
            'Dieser Mitarbeiter hat das ausgewählte Problem übernommen. Möchten Sie ihn entfernen?',
        responsibleUser: 'Verantwortlicher Benutzer',
        responsibleRules: 'Verantwortliche Benutzer - Regeln',
    },
    machines: {
        machines: 'Maschinen',
        xIssuesNotPlanned: ' (nicht geplant)',
        noIssues: 'Keine Probleme',
    },
    maintenance: {
        maintenance: 'Wartung',
    },
    notes: {
        notes: 'Notizen',
        note: 'Notiz',
        title: 'Titel',
        archived: 'Archiviert',
    },
    parts: {
        parts: 'Teile',
        warehouseOutgoings: 'Lagerabgänge',
        fittingEquipmentTypes: 'Passende Ausrüstungstypen',
        goToEquipmentType: 'Gehe zu Ausrüstungstyp',
        selectPart: 'Teil auswählen',
        usageReason: 'Grund',
        usageOtherReason: 'Andere',
        replacements: 'Ersatzteile',
        partEntry: 'Teileintrag',
        goToPart: 'Gehe zu Teil',
        fittingMachines: 'Passende Maschinen',
    },
    costCenter: {
        costCenter: 'Kostenstelle',
    },
    equipmentTypes: {
        equipment: 'Ausrüstung',
        newEquipmentType: 'Neuer Ausrüstungstyp',
        fittingParts: 'Passende Teile',
        goToParts: 'Gehe zu Teilen',
    },
    machinesAndToolsDefinitions: {
        machinesAndToolsDefinitions: 'Maschinen- und Werkzeugdefinitionen',
    },
    flows: {
        flow: 'Flow',
        states: 'Zustände',
        transitions: 'Übergänge',
        state: 'Zustand',
        default: 'Standard',
        warning: 'Warnung',
        problem: 'Problem',
        fixing: 'Behebung',
        finished: 'Fertig',
    },
    parameters: {
        categoryParameter: 'Kategorieparameter',
        equipmentTypeParameter: 'Ausrüstungstypparameter',
    },
    staff: {
        staff: 'Personal',
        editUserAccess: 'Benutzerzugriff bearbeiten',
        permissionsUpdated: 'Berechtigungen aktualisiert',
        passwordUpdated: 'Passwort aktualisiert',
        codeUpdated: 'Code aktualisiert',
        changePasswordAndCode: 'Passwort und Code ändern',
        goToLicenses: 'Gehe zu Lizenzen',
        editAccess: 'Zugriff bearbeiten',
        editUser: 'Benutzer bearbeiten',
        addUser: 'Neuen Benutzer hinzufügen',
        nameAndLastname: '@:common.USER_NAME_LABEL',
        accountStatus: 'Kontostatus',
        phoneNumber: 'Telefonnummer',
        department: 'Abteilung',
        passwordChange: 'Passwortänderung',
        codeChange: 'Codeänderung',
        newPassword: 'Neues Passwort',
        confirmNewPassword: 'Neues Passwort bestätigen',
        changePassword: 'Passwort ändern',
        newCode: 'Neuer Code',
        confirmNewCode: 'Neuen Code bestätigen',
        changeCode: 'Code ändern',
        addEntry: 'Eintrag hinzufügen',
        editEntry: 'Eintrag bearbeiten',
        editLicense: 'Lizenz bearbeiten',
        addLicense: 'Lizenz hinzufügen',
        licenseNumber: 'Lizenznummer',
        prefferedLocale: 'Bevorzugte Spracheinstellung',
        oldPassword: 'Altes Passwort',
        newPasswordConfirmation: 'Neues Passwort bestätigen',
        reading: 'Anzeigen',
        creating: 'Erstellen',
        updating: 'Aktualisieren',
        deleting: 'Löschen',
        importScheduleFile: 'Importieren Sie einen Zeitplan aus einer Datei',
        importSchedule: {
            errors: {
                user_not_found: 'Benutzer nicht gefunden [{user}]',
                user_found_many: '{count} benutzer gefunden [{user}]',
                event_collision: 'Kollision von Ereignissen',
                hour_cell_parse: 'Zellparsing-Fehler',
            },
        },
        oldCode: 'Alter Code',
        newCodeConfirmation: 'Bestätigung des neuen Codes',
        setAccessBasedOnProfile:
            'Gewähren Sie Zugriff basierend auf dem Profil',
        selectAccessMergeType:
            'Wählen Sie aus, wie Berechtigungen kombiniert werden sollen',
        noAccessesInProfileMessage:
            'Das ausgewählte Profil hat keine Berechtigungen. Möchten Sie trotzdem überschreiben?',
    },
    breadCrumb: {
        configuration: 'Konfiguration',
        locations: 'Standorte',
        home: 'Zuhause',
        machines: 'Maschinen',
        tools: 'Werkzeuge',
        issues: 'Probleme',
        notes: 'Notizen',
        maintenance: 'Wartung',
        parts: 'Teile',
        warehouse: 'Lagerhaus',
        dictionary: 'Wörterbuch',
        categories: 'Kategorien',
        parameters: 'Parameter',
        costCenter: 'Kostenstelle',
        flows: 'Flüsse',
        states: 'Zustände',
        transitions: 'Übergänge',
        shiftSchemas: 'Schichtschemata',
        shifts: 'Schichten',
        definitionsOfMachinesAndToolsTypes:
            'Maschinen- und Werkzeugtypen-Definitionen',
        add: 'Hinzufügen',
        edit: 'Bearbeiten',
        staff: 'Personal',
        licenses: 'Lizenzen',
        entries: 'Einträge',
        companiesDatabase: 'Firmen-Datenbank',
        companyManagement: 'Firmenverwaltung',
        companyData: 'Unternehmensdaten',
        supportedLanguages: 'Unterstützte Sprachen',
        en: 'Englisch',
        pl: 'Polnisch',
        es: 'Spanisch',
        de: 'Deutsch',
        defaultLanguage: 'Standard-Sprache',
        notifications: 'Benachrichtigungen',
        notificationsManagement: 'Benachrichtigungsverwaltung',
        myProfile: 'Mein Profil',
    },
    attributeTypes: {
        text: 'Text',
        note: 'Notiz',
        integer: 'Ganzzahl',
        decimal: 'Dezimal',
        date: 'Datum',
        time: 'Uhrzeit',
        dateTime: 'Datum und Uhrzeit',
        color: 'Farbe',
        icon: 'Symbol',
        boolean: 'Ja/Nein',
    },
    costCalculator: {
        costCalculator: 'Kostenrechner',
        waitTime: 'Wartezeit',
        serviceTime: 'Servicezeit',
        suspendTime: 'Stillstandzeit',
        totalTime: 'Gesamtzeit',
        estimatedCost: 'Geschätzte Kosten',
        calculate: 'Berechnen',
        withoutParts: 'Ohne Teile',
        timeOfReportingIssue: 'Zeitpunkt des Meldens des Problems',
        timeOfServiceStart: 'Zeitpunkt des Service-Starts',
        timeOfReportingEnd: 'Zeitpunkt des Endes des Services',
        days: 'Tage',
        hours: 'Stunden',
        minutes: 'Minuten',
        enterNewTime: 'Neue Zeit eingeben',
        fromIssueReportToServiceStart:
            'Zeit vom Melden des Problems bis zum Service-Start',
        fromServiceStartToServiceEnd:
            'Zeit vom Service-Start bis zum Ende des Services',
        workTime: 'Arbeitszeit',
        includeAwaitingTime: 'Wartezeit einbeziehen',
    },
    dashboard: {
        components: {
            myIssues: {
                title: 'Meine Probleme',
                assignedToMe: 'Mir zugewiesen',
                assignedToGroup: 'Meiner Gruppe zugewiesen',
                tookByMe: 'Von mir übernommen',
                takeIssueBtn: 'Übernehmen',
                arriveIssueBtn: 'Ich bin da',
                finishIssueBtn: 'Beenden',
                history: 'Verlauf',
                myResponsible: 'Ich bin verantwortlich für',
            },
        },
    },
    synchronization: {
        enabled: 'Aktiviert',
        hasHeaders: 'Hat Überschriften',
        leaveFile: 'Datei behalten',
        host: 'Host',
        port: 'Port',
        protocol: 'Protokoll',
        username: 'Benutzername',
        password: 'Passwort',
        root: 'Root',
        encoding: 'Kodierung',
        separator: 'Trennzeichen',
        externalSystemId: 'Externes System-ID',
        cronExpression: 'Cron-Ausdruck',
        appendFullStock: 'Vollständigen Bestand anhängen',
        includeHeaders: 'Überschriften einbeziehen',
        withTrashed: 'Mit gelöschten Daten',
        filePattern: 'Dateimuster',
    },
    processes: {
        created_at: 'Erstellt am',
        started_at: 'Gestartet am',
        updated_at: 'Aktualisiert am',
        finished_at: 'Beendet am',
        attempts: 'Versuche',
        queue: 'Warteschlange',
        job_id: 'Job ID',
        job_uuid: 'Job UUID',
        progress_max: 'Maximaler Fortschritt',
        progress_now: 'Aktueller Fortschritt',
        outputMessage: 'Ausgabenachricht',
        status: {
            queued: 'wartend',
            executing: 'ausführend',
            finished: 'beendet',
            failed: 'fehlgeschlagen',
            retrying: 'wiederholend',
            undefined: 'undefiniert',
        },
    },
    weekDays: {
        mo: 'Montag',
        tu: 'Dienstag',
        we: 'Mittwoch',
        th: 'Donnerstag',
        fr: 'Freitag',
        sa: 'Samstag',
        su: 'Sonntag',
    },
    reports: {
        reports: 'Berichte',
        dateFrom: 'Startdatum',
        dateTo: 'Enddatum',
        types: {
            operation_sheet: 'Betriebsblatt',
            issue_summary: 'Zusammenfassung des Problems',
            grouped_summary: 'Kurzbericht',
            storage_operations: 'Lagerbetrieb',
            part_quantity_export: 'Teilemenge',
        },
        reportFor: 'Bericht für',
        includeQuantityLeft0: 'Teile mit Nullmenge einbeziehen',
    },
    logs: {
        issues: {
            escalation:
                'Eskalation ({minutes} Min.) - Benachrichtigung gesendet',
        },
        issueEmployee: {
            assignedAt: 'Mitarbeiter zugewiesen:',
            receivedAt: 'Mitarbeiter hat empfangen:',
            tookAt: 'Mitarbeiter hat übernommen:',
            finishedAt: 'Mitarbeiter hat abgeschlossen:',
            deletedAt: 'Mitarbeiter aus Meldung gelöscht',
        },
    },
    units: {
        no: 'Stück',
        st: 'Satz',
    },
    rrule: {
        frequency: 'Frequenz',
        dtstart: 'Startdatum',
        tzid: 'Zeitzone',
        until: 'Bis',
        count: 'Zählen',
        interval: 'Intervall',
        wkst: 'Starttag',
        byweekday: 'Bis Wochentag',
        bymonth: 'Nach Monaten',
        yearly: 'Jährlich',
        monthly: 'Monatlich',
        weekly: 'Wöchentlich',
        daily: 'Täglich',
        hourly: 'Stündlich',
        minutely: 'Minutiös',
        secondly: 'Zweitens',
        infinitePeriodicityMessage:
            'Die Periodizität ist unendlich, aus Performancegründen werden nur 500 Zeilen angezeigt',
    },
    months: {
        jan: 'Januar',
        feb: 'Februar',
        mar: 'Marsch',
        apr: 'April',
        may: 'Dürfen',
        jun: 'Juni',
        jul: 'Juli',
        aug: 'August',
        sep: 'September',
        oct: 'Oktober',
        nov: 'November',
        dec: 'Dezember',
    },
    charts: {
        charts: 'Diagramme',
        count: 'Anzahl der Ausgaben',
        total: 'Gesamtausgabenzeit (vom Bericht bis zum Abschluss)',
        serw: 'Gesamtreparaturzeit (Ttotal - Twait)',
        mttr1: 'Durchschnittliche Zeit vom Bericht bis zum Ende',
        mttr2: 'Durchschnittliche Zeit von der Aufnahme bis zum Ende',
        mtbf: 'Durchschnittliche Betriebszeit zwischen Ausgaben',
        mttf: 'Durchschnittliche Zeit zwischen Ausgaben',
    },
    accessMergeValues: {
        sum: 'Summe',
        product: 'Produkt',
        overwrite: 'überschreiben',
    },
    tpm: {
        history: 'Geschichte',
        standardObstacle: 'Standardhindernis',
        customObstacle: 'Benutzerdefiniertes Hindernis',
        bhp: 'Arbeitssicherheit und Gesundheitsschutz',
        returnToMainPage: 'Zurück zur Hauptseite',
        bhpMessage:
            'Wenn Sie Sicherheitsrisiken feststellen, melden Sie diese bitte unverzüglich Ihrem direkten Vorgesetzten und verwenden Sie das Meldungsformular unterhalb des Anschlagbretts.',
        ok: 'Ok',
        send: 'Senden',
        description: 'Beschreibung',
        title: 'Titel',
        realization: 'Realisierung',
        answer: 'Antwort',
        pendingSurveys: 'Laufende Umfragen',
        surveys: 'Umfragen',
        systemSurvey: 'Systemumfrage',
        addPage: 'Seite hinzufügen',
        createSurvey: 'Umfrage erstellen',
        addSection: 'Abschnitt hinzufügen',
        addQuestion: 'Frage hinzufügen',
        questionContent: 'Fragetext',
        answerOption: 'Antwortoption',
        addQuestionAnswer: 'Antwortoption hinzufügen',
        surveyName: 'Name der Umfrage',
        sectionName: 'Name des Abschnitts',
        noSurveyAnswers: 'Keine Antworten vorhanden',
        removeSection: 'Abschnitt entfernen',
        published: 'Veröffentlicht',
        unpublished: 'Nicht veröffentlicht',
        pendingPublication: 'Änderungen warten auf Veröffentlichung',
        removeQuestion: 'Frage entfernen',
        removeAnswer: 'Antwortoption entfernen',
        publish: 'Veröffentlichen',
        unpublish: 'Zurückziehen',
        previewResults: 'Ergebnisse anzeigen',
        supervisior: 'Vorgesetzter',
        surveyResults: 'Umfrageergebnisse',
        surveysEvents: 'Konfiguration von Ereignissen - Umfragen',
        operatedBy: 'Betrieben von',
        confirmReadInformations: 'Ich habe die Informationen gelesen',
        noticeContent: 'Inhalt der Bekanntmachung',
        notice: 'Bekanntmachung',
        surveyEventName: 'Name des Ereignisses',
        survey: 'Umfrage',
        newIssue: 'Neues Problem',
        surveyEventConfigurationAlreadyExists:
            'Diese Konfiguration ist bereits vorhanden',
        lastComment: 'Letzter Kommentar der verantwortlichen Person',
        surveyNotConfigured: 'Umfrage nicht konfiguriert',
        fillSurvey: 'Füllen Sie die Umfrage aus',
        singleSurveyEntries: 'einzelne Ergebnisse',
        groupedSurveyEntries: 'Gruppierte Ergebnisse',
        publicationId: 'Publikations-ID',
        publicationDate: 'Veröffentlichungsdatum',
        versionId: 'Versions-ID',
        answersCount: 'Anzahl der Antworten',
        answers: 'Antworten',
        withoutSupervisor: 'Kein Vorgesetzter',
        defaultSupervisor: 'Standard-Supervisor',
        flowStateFlags: 'Statusflags',
        qrActionsSettings: 'Einstellungen für QR-Code-Aktionen',
        loginRequired: 'Erfordert eine Anmeldung',
        questionContext: 'Den Kontext der Frage',
        currentSurveyVersionPreview:
            'Vorschau auf die aktuelle Version der Umfrage',
        surveyDescription: 'Beschreibung der Umfrage',
        sectionDescription: 'Abschnittsbeschreibung',
        instructions: 'Anweisungen',
        instruction: 'Anweisung',
        instructionRevisions: 'Überarbeitungen',
        instructionRevision: 'Revision',
        checklists: 'Checklisten',
        checklist: 'Checkliste',
        checklistItem: 'Listenpunkt',
        manageChecklistFields: 'Listenelemente verwalten',
        checklistItemDisplayOptions: 'Angezeigte Artikel',
        revisionAutoRejectedInfo: '[System] Abgelehnt – neue Revision erstellt',
    },
    checklists: {
        itemBasic: 'Basiselement',
        itemSeparator: 'Separator',
        itemSection: 'Abschnitt',
        publish: 'Veröffentlichen',
        previewCurrentVersion: 'Vorschau der aktuellen Version',
    },
};
